export interface ApiCreateAsyncTranslateTaskRequest {
    task_id: string;
}

export type ApiCreateAsyncTranslateTaskResponse = boolean;

/**
 * 创建异步翻译任务
 */
export interface CreateAsyncTranslateTaskApi {
    /**
     * 创建异步翻译任务
     * @param data 创建异步翻译任务请求
     */
    createAsyncTranslateTask(data: ApiCreateAsyncTranslateTaskRequest): Promise<ApiCreateAsyncTranslateTaskResponse>;
}

export const CreateAsyncTranslateTaskApi = Symbol('CreateAsyncTranslateTaskApi');
